// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayer_container__MDJbf","playerBox":"VideoPlayer_playerBox__chPlc","infoBox":"VideoPlayer_infoBox__xhYeV","commentBox":"VideoPlayer_commentBox__A6m9n"};